import { t } from 'src/lib/i18n'

import schedule from './assets/schedule.svg'
import review from './assets/review.svg'
import rocket from './assets/rocket.svg'
import mountain from './assets/mountain.svg'

export const NUDGE_TYPES = {
  schedule: {
    imageUrl: schedule,
    buttonText: t('Find a time'),
    titleText: t('Meet a Tutor Online'),
    bodyText: [
      t(
        'No matter your language level, our experienced tutors can guide you through an easy and fun lesson.'
      ),
    ],
    buttonType: 'primaryAdvanced',
    imageFirst: true,
  },
  review_live_lesson: {
    imageUrl: review,
    buttonText: t('Review my Lesson'),
    titleText: t('Nice job!'),
    bodyText: [t('You completed your first Live Lesson.')],
    buttonType: 'primaryAdvanced',
    imageFirst: false,
  },
  subscribe: {
    imageUrl: rocket,
    buttonText: t('Choose a subscription'),
    titleText: t('Join Chatterbug'),
    bodyText: [
      t('Flexible lesson scheduling'),
      t('A fully integrated curriculum'),
      t('Certification after each CEFR level'),
    ],
    buttonType: 'ctaTheme2',
    imageFirst: true,
  },
  set_goals: {
    imageUrl: mountain,
    buttonText: t('Set your goals'),
    titleText: t('Set up your goals'),
    bodyText: [
      t(
        'Tell us what your language learning goals are and we’ll help you achieve them!'
      ),
    ],
    buttonType: 'primaryAdvanced',
    imageFirst: true,
  },
}
